import { MaterialSlot } from "@/3d/material/MaterialSlot";
import { ColorView } from "@/dom/components/ColorSelect/ColorSelect";
import { Dropdown } from "@/dom/components/Dropdown/Dropdown";
import { Row } from "@/dom/components/Panel/Row";
import { Section } from "@/dom/components/Panel/Section";
import { Furniture, FurnitureInstance } from "@/state/Furniture";
import { MaterialResources } from "@/state/MaterialResources";
import React, { useMemo } from "react";
import { Color } from "three";

type MaterialSlotViewProps = {
    slot: MaterialSlot;
    instance: FurnitureInstance;
    furniture: Furniture;
    availableMaterials: MaterialResources[];
    onMaterialNameChange: (materialName: string) => void;
    onMaterialColorChange: (color: Color) => void;
};

export const MaterialSlotView: React.FC<MaterialSlotViewProps> = ({
    slot,
    instance,
    furniture,
    availableMaterials,
    onMaterialNameChange,
    onMaterialColorChange,
}) => {
    const colors = useMemo(
        () => furniture.data.colors.map((color) => new Color(color)),
        [furniture.data.colors]
    );

    const slotMapping = useMemo(() => {
        return instance.instance.materialSlotMapping[slot.id];
    }, [instance.instance.materialSlotMapping, slot.id]);

    return (
        <React.Fragment>
            <Section key={slot.id} title={slot.name}>
                <Dropdown
                    options={availableMaterials.map((material) => ({
                        label: material.config.name,
                        value: material.config.name,
                    }))}
                    value={slotMapping?.materialName}
                    onChange={(material) => {
                        onMaterialNameChange(material);
                    }}
                />
            </Section>
            <Section title="Цвет">
                <Row justify="flex-start">
                    {colors.map((color, index) => (
                        <ColorView
                            size="large"
                            key={index}
                            color={color}
                            onClick={() => onMaterialColorChange(color)}
                            isSelected={slotMapping?.color === color}
                        />
                    ))}
                </Row>
            </Section>
        </React.Fragment>
    );
};
